import { render } from "./SectionH.vue?vue&type=template&id=1c214a2c&scoped=true"
import script from "./SectionH.vue?vue&type=script&lang=js"
export * from "./SectionH.vue?vue&type=script&lang=js"

import "./SectionH.vue?vue&type=style&index=0&id=1c214a2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c214a2c"]])

export default __exports__